<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <VDialog v-model="dialogLoading" :max-width="700">
    <VCard class="pa-sm-10 pa-5">
      <VCardTitle class="text-center">Cargando información</VCardTitle>
      <VProgressLinear indeterminate color="primary"></VProgressLinear>
    </VCard>
  </VDialog>

  <VDialog v-model="dialogConfirm" :max-width="500">
    <VCard class="pa-sm-10 pa-5">
      <VCardTitle class="text-center">Atención</VCardTitle>
      <VCardText>Esta seguro de eliminar este elemento?</VCardText>
      <VBtn type="button" class="btn btn-primary input-group-text" @click="afterConfirm">
        <VIcon icon="fas fa-check"></VIcon> Aceptar
      </VBtn>
      <VBtn type="button" @click="dialogConfirm = false" class="btn btn-danger input-group-text">
        <VIcon icon="fas fa-close"></VIcon> Cerrar
      </VBtn>
    </VCard>
  </VDialog>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content report-box container-fluid">

      <div>
        <h1>{{ $store.getters.currentAdminLanguage === 'en' ? 'Welcome' : 'Bienvenido' }}</h1>
      </div>
      <!-- Page Header -->
      <div class="page-header subscribe-head">
        <div class="row align-items-center">
          <breadcrumbthree :title="title" :text="text" :text1="text1" />
        </div>
      </div>
      <div class="row">
        <h2>Sección 1</h2>
        <form class="mb-4" @submit.prevent="updateSection(
          section_zero.page,
          section_zero.section,
          section_zero.language,
          section_zero
        )">
          <div class="page-header subscribe-head">
            <div class="row align-items-center">
              <div class="col-sm-6">
                <template v-for="(phrase, inx) in section_zero.phrases">
                  <div class="form-group">
                    <label>Frase {{ inx+1 }}:</label>
                    <div class="input-group">
                      <input
                          type="text"
                          class="form-control"
                          v-model="phrase.title"
                      />
<!--                      <div class="input-group-append">-->
<!--                        <button type="button" @click="deleteTitlePrhase(inx)" class="btn btn-danger input-group-text"><i class="fas fa-trash"></i></button>-->
<!--                      </div>-->
                    </div>
                  </div>
                </template>
                <button type="button" @click="appendTitlePrhase" class="btn btn-primary">
                  <i class="fas fa-plus"></i> Agregar </button>
              </div>
              <div class="col-sm-4">
                <label>Contenido principal:</label>
                <textarea class="form-control" v-model="section_zero.content.title" style="min-height:135px" placeholder="Contenido principal"></textarea>
              </div>
              <div class="col-sm-2">
                <div class="col-auto" style="float:right">
                  <button type="submit" class="btn btn-primary">
                    <i class="fas fa-save"></i> Guardar </button>
                </div>
              </div>
            </div>
          </div>
        </form>
        <form class="mb-4" @submit.prevent="chargeSliders">
          <div class="form-group">
            <label>Imagenes Slider:</label>
            <div class="row align-items-center">
              <div class="col-sm-3" v-for="image in section_seven">
                <v-hover v-slot="{ isHovering, props }">
                  <v-img :src="image.s3_url_two" cover class="mt-2">
                    <div class="align-self-center">
                      <v-btn variant="text" style="color:white; background-color: #0A0A0A; opacity: 0.5;" @click="deleteImage(image.idcontent)">
                        <v-icon icon="fas fa-trash"></v-icon>
                      </v-btn>
                    </div>
                  </v-img>
                </v-hover>
              </div>
            </div>
            <br/>
            <div class="row">
              <div class="col-sm-8">
                <div class="input-group">
                  <input
                      type="file"
                      class="form-control"
                      multiple
                      @change="onSelectFiles($event)"
                  />
                </div>
              </div>
              <div class="col-sm-2">
                <div class="col-auto" style="float:right">
                  <button type="submit" class="btn btn-primary">
                    <i class="fas fa-save"></i> Guardar </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <hr>

      <div class="row">
        <h2>Sección 2</h2>
        <form
          class="mb-4"
          @submit.prevent="
          updateSection(
          section_one.page,
          section_one.section,
          section_one.language,
          section_one)"
        >
          <div class="page-header subscribe-head">
            <div class="row align-items-center">
              <div class="col-sm-8">
                <div class="form-group">
                  <label>Título:</label>
                  <input
                  type="text"
                  class="form-control"
                  v-model="section_one.title"
                  />
                </div>
              </div>
              <div class="col-sm-4">
                <div class="col-auto" style="float:right">
                  <button type="submit" class="btn btn-primary">
                    <i class="fas fa-save"></i> Guardar </button>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-8">
              <div class="form-group">
                <label>Párrafo Principal</label>
                <textarea
                class="form-control"
                name="txt-quienessomos"
                placeholder=""
                style="min-height:395px"
                v-model="section_one.text"
                >
                </textarea>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label>Imagen</label>
                <input
                type="file"
                class="form-control"
                name="txt-imagen"
                accept="image/png, image/gif, image/jpeg"
                @change="handlePhotoChangeSection($event, 'section_one')"
                />
                  <div class="img-preview" style="height: 350px">
                    <img :src="img_preview_section_one ? img_preview_section_one : section_one.s3_url"/>
                  </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="row">
        <h2>Sección 3</h2>
        <div class="col-xs-12">
          <form
              class="mb-4"
              @submit.prevent="
            updateSection(
            section_eight.page,
            section_eight.section,
            section_eight.language,
            section_eight)"
          >
            <div class="page-header subscribe-head">
              <div class="row align-items-center">
                <div class="col-sm-5">
                  <div class="form-group">
                    <label>Título:</label>
                    <input
                        type="text"
                        class="form-control"
                        v-model="section_eight.title"
                    />
                  </div>
                </div>
                <div class="col-sm-5">
                  <label>Contenido principal:</label>
                  <textarea class="form-control" v-model="section_eight.text" style="min-height:135px" placeholder="Contenido principal"></textarea>
                </div>
                <div class="col-sm-2">
                  <div class="col-auto" style="float:right">
                    <button type="submit" class="btn btn-primary">
                      <i class="fas fa-save"></i> Guardar </button>
                  </div>
                </div>
              </div>
              <div class="row">
                <h3>Indicadores</h3>
                <div class="col-sm-4">
                  <template v-for="(ind, inx) in section_eight.indicadores">
                    <label>Indicador {{ inx+1 }}</label>
                    <input type="text" class="form-control" v-model="ind.title" placeholder="Indicador {{ inx+1 }}" required>
                  </template>
                </div>
                <div class="col-sm-4">
                  <template v-for="(ind, inx) in section_eight.indicadores">
                    <label>Descripción {{ inx+1 }}</label>
                    <input type="text" class="form-control" v-model="ind.subtitle" placeholder="Descripción {{ inx+1 }}" required>
                  </template>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="row">
        <h2>Sección 4</h2>
        <div class="col-xs-12 ">
          <form
              class="mb-4"
              @submit.prevent="uploadPhotoCarousel">
            <div class="row">
              <div class="col-sm-10">
                <div class="form-group">
                  <label>Imagenes carouse:</label>
                  <div class="row align-items-center" style="float:left; width:100%; overflow-y: auto; max-height: 600px">
                      <div class="col-sm-3" v-for="image in section_nine">
                        <v-hover v-slot="{ isHovering, props }">
                          <v-img :src="image.s3_url_two" cover class="mt-2">
                            <div class="align-self-center">
                              <v-btn variant="text" style="color:white; background-color: #0A0A0A; opacity: 0.5;" @click="deleteImageCarousel(image.idcontent)">
                                <v-icon icon="fas fa-trash"></v-icon>
                              </v-btn>
                            </div>
                          </v-img>
                        </v-hover>
                      </div>
                  </div>
                  <input
                      type="file"
                      class="form-control"
                      name="txt-imagen"
                      multiple
                      accept="image/png, image/gif, image/jpeg"
                      @change="handlePhotoaCarousel($event)"
                  />
                </div>
              </div>
              <div class="col-sm-2">
                <div class="col-auto" style="float:right">
                  <button class="btn btn-primary">
                    <i class="fas fa-save"></i> Guardar </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="row">
        <h2>Sección 5</h2>
        <div class="col-xs-12 ">
          <form
              class="mb-4"
              @submit.prevent="uploadVideoRepre">
            <div class="row">
              <div class="col-sm-10">
                <div class="form-group">
                  <label>Video representación:</label><br>
                  <video class="video-silde active" height="300" :src="section_ten.s3_video_url" autoplay muted loop />
                  <input
                      type="file"
                      class="form-control"
                      name="txt-video"
                      accept="video/mp4"
                      @change="handleVideoRepre($event)"
                  />
                </div>
              </div>
              <div class="col-sm-2">
                <div class="col-auto" style="float:right">
                  <button class="btn btn-primary">
                    <i class="fas fa-save"></i> Guardar </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="row">
        <h2>Sección 6</h2>
        <div class="col-xs-12 col-sm-6">
          <form 
            class="mb-4" 
            @submit.prevent="
            updateSection(
            section_two.page,
            section_two.section,
            section_two.language,
            section_two)"
          >
            <div class="page-header subscribe-head">
              <div class="row align-items-center">
                <div class="col-sm-8">
                  <div class="form-group">
                    <label>Título:</label>
                    <input 
                      type="text" 
                      class="form-control" 
                      v-model="section_two.title"
                    />
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="col-auto" style="float:right">
                    <button class="btn btn-primary">
                      <i class="fas fa-save"></i> Guardar </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label>Url Video</label>
                  <input 
                  type="text" 
                  class="form-control" 
                  v-model="section_two.video"
                  />
                </div>
                <div style="padding:56.25% 0 0 0;position:relative;width:100%;">
                  <iframe 
                    :src="section_two.video" 
                    frameborder="0" 
                    allow="autoplay; picture-in-picture; clipboard-write;" 
                    style="position:absolute;top:0;left:0;width:100%;height:100%;"
                  >
                  </iframe>
                </div>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label>Vídeo</label>
                  <input type="file" class="form-control" name="txt-video" accept="video/mp4,video/x-m4v,video/*"/>
                    <div class="ver-video">
                      <button title="Quitar" class="btn btn-danger"><i class="fa fa-trash"></i></button>
                      <video controls>
                        <source src="@/assets/talento_agv/video/PROPÓSITO.mp4" />
                      </video>
                    </div>
                </div>
              </div>
            </div> -->
          </form>
        </div>

        <div class="col-xs-12 col-sm-6">
          <form 
            class="mb-4" 
            @submit.prevent="
            updateSection(
            section_four.page,
            section_four.section,
            section_four.language,
            section_four)"
          >
            <div class="page-header subscribe-head">
              <div class="row align-items-center">
                <div class="col-sm-8">
                  <div class="form-group" >
                    <label>Título:</label>
                    <input type="text" class="form-control" v-model="section_four.title"/>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="col-auto" style="float:right">
                    <button class="btn btn-primary">
                      <i class="fas fa-save"></i> Guardar </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label>Url Video:</label>
                  <input type="text" class="form-control" v-model="section_four.video"/>
                </div>
                <div style="padding:56.25% 0 0 0;position:relative;width:100%;">
                  <iframe 
                    :src="section_four.video" 
                    frameborder="0" 
                    allow="autoplay; picture-in-picture; clipboard-write;" 
                    style="position:absolute;top:0;left:0;width:100%;height:100%;"
                  >
                  </iframe>
                </div>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label>Vídeo</label>
                  <input type="file" class="form-control" name="txt-video" accept="video/mp4,video/x-m4v,video/*"/>
                    <div class="ver-video">
                      <button title="Quitar" class="btn btn-danger"><i class="fa fa-trash"></i></button>
                      <video controls>
                        <source src="@/assets/talento_agv/video/PROPÓSITO.mp4" />
                      </video>
                    </div>
                </div>
              </div>
            </div> -->
          </form>
        </div>
      </div>

      <!-- /Page Header -->
      <div class="page-header subscribe-head">
        <div class="row align-items-center">
          <h3 class="page-title">
            <span>Nuestros Valores</span>
            <div class="col-auto" style="float:right">
              <a
                class="btn add-user"
                href="javascript:;"
                data-bs-toggle="m odal"
                data-bs-target="#add_value"
                @click="clearValuesValue"
              >
                <i class="fas fa-plus"></i> Agregar Registro </a>
            </div>
          </h3>

        </div>
      </div>


      <div class="row">
        <h2>Sección 7</h2>
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="showentries">
                <label
                  >Mostrar
                  <select>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  Registros
                </label>
                <div class="entries">
                  <span>Buscar: </span>
                  <input
                    type="search"
                    class="form-control form-control-sm ms-2"
                    placeholder=""
                    aria-controls="DataTables_Table_0"
                    v-model="searched_value"
                    @input="localSearch(searched_value,dataTableValues,'valores')"
                  />
                </div>
              </div>
              <div class="table-responsive">
                <a-table
                  class="stripped table-hover"
                  :columns="columnsTableValues"
                  :data-source="dataTableFiltValues"
                >
                  <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'description'">
                        <div>{{ record.description }}</div>
                    </template>
                    <template v-if="column.key === 'photo'">
                        <div>
                          <img :src="record.photo" style="max-width:64px"/>
                        </div>
                    </template>
                    <template v-if="column.key === 's3_url'">
                        <div><img :src="record.s3_url" style="max-width:64px"/></div>
                    </template>
                    <template v-else-if="column.key === 'id'">
                      <div class="text-end">
                        <a
                          href="javascript:void(0);"
                          class="btn btn-sm btn-secondary me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit_value"
                          @click="loadEditModalValue(record)"
                          ><i class="far fa-edit"></i
                        ></a>
                        <a
                          href="javascript:void(0);"
                          class="btn btn-sm btn-danger"
                          data-bs-toggle="modal"
                          data-bs-target="#delete_value"
                          @click="loadDeleteModalValue(record)"
                          ><i class="far fa-trash-alt"></i
                        ></a>
                      </div>
                    </template>
                  </template>
                </a-table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- /Page Header -->
      <div class="page-header subscribe-head">
        <div class="row align-items-center">
          <h3 class="page-title">
            <span>Noticias</span>
            <div class="col-auto" style="float:right">
              <a
                  class="btn add-user"
                  href="javascript:;"
                  data-bs-toggle="modal"
                  data-bs-target="#add_notice"
                  @click="clearValuesValue"
              >
                <i class="fas fa-plus"></i> Agregar Registro </a>
            </div>
          </h3>

        </div>
      </div>

      <div class="row">
        <h2>Sección 8</h2>
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="showentries">
                <label
                >Mostrar
                  <select>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  Registros
                </label>
                <div class="entries">
                  <span>Buscar: </span>
                  <input
                      type="search"
                      class="form-control form-control-sm ms-2"
                      placeholder=""
                      aria-controls="DataTables_Table_0"
                      v-model="searched_card"
                      @input="localSearch(searched_card,dataTableCards,'cards')"
                  />
                </div>
              </div>
              <div class="table-responsive">
                <a-table
                    class="stripped table-hover"
                    :columns="columnsTableNotices"
                    :data-source="dataTableNotices"
                >
                  <template #bodyCell="{ column, record }">
<!--                    <template v-if="column.key === 'title'">-->
<!--                      <div>{{ record.title }}</div>-->
<!--                    </template>-->
<!--                    <template v-if="column.key === 'description'">-->
<!--                      <div>{{ record.description }}</div>-->
<!--                    </template>-->
<!--                    <template v-if="column.key === 'photo'">-->
<!--                      <div><img :src="record.photo" style="max-width:64px"/></div>-->
<!--                    </template>-->
<!--                    <template v-if="column.key === 's3_url'">-->
<!--                      <div><img :src="record.s3_url" style="max-width:64px"/></div>-->
<!--                    </template>-->
                    <template v-if="column.dataIndex === 'id'">
                      <div class="text-end">
                        <a
                            href="javascript:void(0);"
                            class="btn btn-sm btn-secondary me-2"
                            data-bs-toggle="modal"
                            data-bs-target="#add_notice"
                            @click="loadEditModalNotice(record)"
                        ><i class="far fa-edit"></i
                        ></a>
                        <a
                            href="javascript:void(0);"
                            class="btn btn-sm btn-danger"
                            data-bs-toggle="modal"
                            data-bs-target="#delete_card"
                            @click="loadDeleteModalNotice(record)"
                        ><i class="far fa-trash-alt"></i>
                        </a>
                      </div>
                    </template>
                  </template>
                </a-table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- /Page Header -->
      <div class="page-header subscribe-head">
        <div class="row align-items-center">
          <h3 class="page-title">
            <span>Transformando Tierras, Transformando Vidas</span>
            <div class="col-auto" style="float:right">
              <a
                class="btn add-user"
                href="javascript:;"
                data-bs-toggle="modal"
                data-bs-target="#add_card"
                @click="clearValuesCard"
              >
                <i class="fas fa-plus"></i> Agregar Registro </a>
            </div>
          </h3>

        </div>
      </div>
      <div class="row">
        <h2>Sección 9</h2>
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="showentries">
                <label
                  >Mostrar
                  <select>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  Registros
                </label>
                <div class="entries">
                  <span>Buscar: </span>
                  <input
                    type="search"
                    class="form-control form-control-sm ms-2"
                    placeholder=""
                    aria-controls="DataTables_Table_0"
                    v-model="searched_card"
                    @input="localSearch(searched_card,dataTableCards,'cards')"
                  />
                </div>
              </div>
              <div class="table-responsive">
                <a-table
                  class="stripped table-hover"
                  :columns="columnsTableCards"
                  :data-source="dataTableFiltCards"
                >
                  <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'title'">
                        <div>{{ record.title }}</div>
                    </template>
                    <template v-if="column.key === 'description'">
                        <div>{{ record.description }}</div>
                    </template>
                    <template v-if="column.key === 'photo'">
                        <div><img :src="record.photo" style="max-width:64px"/></div>
                    </template>
                    <template v-if="column.key === 's3_url'">
                        <div><img :src="record.s3_url" style="max-width:64px"/></div>
                    </template>
                    <template v-else-if="column.key === 'id'">
                      <div class="text-end">
                        <a
                          href="javascript:void(0);"
                          class="btn btn-sm btn-secondary me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit_card"
                          @click="loadEditModalCard(record)"
                          ><i class="far fa-edit"></i
                        ></a>
                        <a
                          href="javascript:void(0);"
                          class="btn btn-sm btn-danger"
                          data-bs-toggle="modal"
                          data-bs-target="#delete_card"
                          @click="loadDeleteModalCard(record)"
                          ><i class="far fa-trash-alt"></i>
                        </a>
                      </div>
                    </template>
                  </template>
                </a-table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <h2>Sección 10</h2>
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <form 
                class="mb-4" 
                @submit.prevent="
                updateSection(
                section_six.page,
                section_six.section,
                section_six.language,
                section_six)"
              >
                <div class="page-header subscribe-head">
                  <div class="row align-items-center">
                    <div class="col-sm-7">
                      <div class="form-group" >
                        <label>Título:</label>
                        <input type="text" class="form-control" v-model="section_six.title"/>
                      </div>
                    </div>
                    <div class="col-sm-5">
                      <div class="col-auto" style="float:right">
                        <button class="btn btn-primary">
                          <i class="fas fa-save"></i> Guardar </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-7">
                    <div class="form-group">
                      <label>Subtitulo</label>
                      <input 
                      type="text" 
                      class="form-control" 
                      v-model="section_six.subtitle"
                      />
                    </div>
                    <div class="form-group">
                      <label>Párrafo Principal</label>
                      <textarea
                      class="form-control"
                      name="txt-quienessomos"
                      placeholder=""
                      style="min-height:100px"
                      v-model="section_six.text"
                      >
                      </textarea>
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <div class="form-group">
                      <label>Imagen</label>
                      <input 
                      type="file" 
                      class="form-control" 
                      name="txt-imagen" 
                      accept="image/png, image/gif, image/jpeg"
                      @change="handlePhotoChangeSection($event, 'section_six')"
                      />
                        <div class="img-preview" style="height: 150px">
                          <img :src="img_preview_section_six ? img_preview_section_six : section_six.s3_url"/>
                        </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <!-- /Page Wrapper -->

  <!------------------------------------- Modales Noticias ------------------------------------>
  <!-- Add Modal -->
  <div class="modal fade custom-modal" id="add_notice">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Guardar Noticia</h4>
          <button type="button" class="close" data-bs-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <form @submit.prevent="addNoticeValue">
            <div class="form-group">
              <label>Descripcion</label>
              <input
                  class="form-control"
                  name="txt-title-notice"
                  v-model="title_notice_value"
              />
            </div>
            <div class="form-group">
              <label>Contenido</label>
              <textarea
                  class="form-control"
                  name="txt-content-notice"
                  row="10"
                  v-model="content_notice_value"
              ></textarea>
            </div>
            <div class="form-group">
              <label>URL de Linkedin</label>
              <textarea
                  class="form-control"
                  name="txt-url-linkedin"
                  row="10"
                  v-model="url_linkedin"
              ></textarea>
            </div>
            <div class="form-group">
              <label>Imagen</label>
              <input
                  type="file"
                  class="form-control"
                  name="txt-imagen"
                  accept="image/png, image/gif, image/jpeg"
                  @change="handlePhotoChangeValueNotice"
              />
            </div>
            <div class="mt-4">
              <button type="submit" class="btn btn-agv-dos btn-block" data-bs-dismiss="modal">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /The Modal -->

  <!-------------------------------------- Modales Valores -------------------------------------->
  <!-- Add Modal -->
  <div class="modal fade custom-modal" id="add_value">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Agregar Registro</h4>
          <button type="button" class="close" data-bs-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <form @submit.prevent="addValue">
            <div class="form-group">
              <label>Descripcion</label>
              <input 
              class="form-control" 
              name="txt-rotulo" 
              v-model="desc_value"
              />
            </div>
            <div class="form-group">
              <label>Imagen</label>
              <input 
              type="file" 
              class="form-control" 
              name="txt-imagen" 
              accept="image/png, image/gif, image/jpeg" 
              @change="handlePhotoChangeValue"
              />
              <div class="img-preview">
                <!-- <button title="Quitar" class="btn btn-danger"><i class="fa fa-trash"></i></button> -->
                <img :src="img_preview_value"/>
              </div>
            </div>
            <div class="mt-4">
              <button type="submit" class="btn btn-agv-dos btn-block" data-bs-dismiss="modal">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /The Modal -->
  <!-- Edit Modal -->
  <div class="modal fade custom-modal" id="edit_value">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Editar Registro</h4>
          <button type="button" class="close" data-bs-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <form @submit.prevent="editValue">
            <div class="form-group">
              <label>Descripcion</label>
              <input class="form-control" name="txt-rotulo" v-model="desc_value"/>
            </div>
            <div class="form-group">
              <label>Imagen</label>
              <input 
              type="file" 
              class="form-control" 
              name="txt-imagen" 
              accept="image/png, image/gif, image/jpeg"
              @change="handlePhotoChangeValue"
              />
              <div class="img-preview">
                <!-- <button title="Quitar" class="btn btn-danger"><i class="fa fa-trash"></i></button> -->
                <img :src="img_preview_value"/>
              </div>
            </div>
            <div class="mt-4">
              <button type="submit" class="btn btn-agv-dos btn-block" data-bs-dismiss="modal">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Modal -->
  <!-- Delete modal -->
  <div class="modal custom-modal fade" id="delete_value" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Eliminar</h3>
            <p>¿Esta seguro de eliminar este registro de forma permanente?</p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a href="javascript:void(0);" class="btn btn-agv-dos continue-btn" data-bs-dismiss="modal" @click="deleteValue(record)"
                  >Eliminar</a
                >
              </div>
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  data-bs-dismiss="modal"
                  class="btn btn-agv-dos cancel-btn"
                  >Cancelar</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete modal -->

  <!-------------------------------------- Modales Cards -------------------------------------->
  
  <!-- Add Modal -->
  <div class="modal fade custom-modal" id="add_card">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Agregar Registro</h4>
          <button type="button" class="close" data-bs-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <form @submit.prevent="addCard">
            <div class="form-group">
              <label>Title</label>
              <input class="form-control" name="txt-rotulo" v-model="title_card" />
            </div>
            <div class="form-group">
              <label>Descripción</label>
              <textarea 
              class="form-control" 
              name="txt-descripcion"
              v-model="desc_card">
              </textarea>
            </div>
            <div class="form-group">
              <label>Url Texto</label>
              <input class="form-control" name="txt-rotulo" v-model="text_url_card" />
            </div>
            <div class="form-group">
              <label>Imagen</label>
              <input 
              type="file" 
              class="form-control" 
              name="txt-imagen" 
              accept="image/png, image/gif, image/jpeg"
              @change="handlePhotoChangeCard"
              />
              <div class="img-preview">
                <img :src="img_preview_card"/>
              </div>
            </div>
            <div class="mt-4">
              <button type="submit" class="btn btn-agv-dos btn-block" data-bs-dismiss="modal">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Modal -->
  <!-- Edit Modal -->
  <div class="modal fade custom-modal" id="edit_card">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Editar Registro</h4>
          <button type="button" class="close" data-bs-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <form @submit.prevent="editCard">
            <div class="form-group">
              <label>Titulo</label>
              <input 
              class="form-control" 
              name="txt-rotulo" 
              v-model="title_card"
              />
            </div>
            <div class="form-group">
              <label>Descripción</label>
              <textarea 
              class="form-control" 
              name="txt-descripcion" 
              v-model="desc_card">
              </textarea>
            </div>
            <div class="form-group">
              <label>Url Texto</label>
              <input 
              class="form-control" 
              name="txt-rotulo" 
              v-model="text_url_card" 
              />
            </div>
            <div class="form-group">
              <label>Imagen</label>
              <input 
              type="file" 
              class="form-control" 
              name="txt-imagen" 
              accept="image/png, image/gif, image/jpeg"
              @change="handlePhotoChangeCard"
              />
              <div class="img-preview">
                <!-- <button title="Quitar" class="btn btn-danger"><i class="fa fa-trash"></i></button> -->
                <img :src="img_preview_card"/>
              </div>
            </div>
            <div class="mt-4">
              <button type="submit" class="btn btn-agv-dos btn-block" data-bs-dismiss="modal">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Modal -->
  <!-- Delete modal -->
  <div class="modal custom-modal fade" id="delete_card" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Eliminar</h3>
            <p>¿Esta seguro de eliminar este registro de forma permanente?</p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a href="javascript:void(0);" class="btn btn-agv-dos continue-btn" data-bs-dismiss="modal" @click="deleteCard(record)"
                  >Eliminar</a
                >
              </div>
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  data-bs-dismiss="modal"
                  class="btn btn-agv-dos cancel-btn"
                  >Cancelar</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete modal -->

</template>

<style>
    .ver-video{
        padding: 16px;
        max-width: 100%;
        position: relative;
    }

    .ver-video video{
      width: 100%;
    }

    .img-preview{
        margin-top: 10px;
        margin-bottom: 10px;
        position: relative;
    }

    .img-preview img{
      height: 100%;
    }
/* 
    .ver-imagen button, .ver-video button {
        position: absolute;
        right: 16px;
        top: 16px;
    } */
</style>

<script>

const fnbaseToCols = (column) => {
  return {
        title: column.title,
        dataIndex: column.dataIndex,
        key: column.dataIndex,
        sorter : false,
        class: column?.class ?? "" ,
    }
};

const baseColsTableValues = [
  // { title: "N°", dataIndex: "index"},
  { title: "Descripcion", dataIndex: "description"},
  { title: "Imagen", dataIndex: "s3_url"},
  // { title: "Imagen", dataIndex: "photo"},
  { title: "Acciones", dataIndex: "id", class: "text-end"},
];
const columnsTableValues = baseColsTableValues.map ( fnbaseToCols );

const baseColsTableCards = [
  // { title: "N°", dataIndex: "index"},
  { title: "Titulo", dataIndex: "title"},
  { title: "Descripción", dataIndex: "description"},
  { title: "Url Texto", dataIndex: "text_url"},
  // { title: "Imagen", dataIndex: "photo"},
  { title: "Imagen", dataIndex: "s3_url"},
  { title: "Acciones", dataIndex: "id", class: "text-end"},
];
const columnsTableCards = baseColsTableCards.map (  fnbaseToCols );

import axiosIns from '@/plugins/axios.js';
import { ref } from 'vue';
import { router } from "@/router";
import { mapState, mapGetters } from 'vuex';
const currentDate = ref(new Date());

export default {
  data() {
    return {

      columnsTableValues,
      columnsTableCards,
      columnsTableNotices: [
        { title: "Titulo", dataIndex: "title" },
        { title: "Contenido", dataIndex: "content" },
        { title: "URL Linkedin", dataIndex: "url" },
        { title: "Acciones", dataIndex: "id", class: "text-end"},
      ],
      title: "Inicio",
      text: "Mantenimientos Páginas",
      text1: "Inicio",
      filterInputsDisplay: "none",
      startdate: currentDate,
      dialogLoading: false,
      dialogConfirm: false,

      // varibles para el notice
      title_notice_value: '',
      content_notice_value: '',
      url_linkedin: '',
      id_notice: 0,
      
      dataTableValues:[],
      dataTableFiltValues:[],
      dataTableCards:[],
      dataTableFiltCards:[],
      dataTableNotices: [],
      section_zero: {
        phrases: [],
        content: { id: -1, title: "" }
      },
      image_sliders: null,
      image_carousel: [],
      video_repre: null,
      section_one:[],
      section_two:[],
      section_three:[],
      section_four:[],
      section_five:[],
      section_six:[],
      section_seven: [],
      section_nine: [],
      section_eight: {
        indicadores: []
      },
      section_ten: [],
      section_eleven: [],

      img_section_one: null,
      img_preview_section_one: null,
      img_section_six: null,
      img_preview_section_six: null,

      id_value: null,
      desc_value: null,
      img_value: null,
      img_notice_value: null,
      img_preview_value: null,
      searched_value:null,

      id_card: null,
      title_card: null,
      desc_card: null,
      text_url_card: null,
      img_card: null,
      img_preview_card: null,
      searched_card:null,

      language:null,
      idCurrent: 0
      
    };
  },
  beforeRouteEnter(to, from, next){
    if (!localStorage.getItem('userData')) {
      // Redirigir al usuario a la página de inicio de sesión si no está autenticado
      // next({ name: '/admin/login' , params:'empty'})
      router.push('/admin/login');
    }else{
      next()
    }
  },
  mounted(){
    this.getMainPageData()
    this.getValues()
    this.getCards()
  },
  methods: {
    afterConfirm(){},

    handlePhotoaCarousel(event){ this.image_carousel = event.target.files } ,

    handleVideoRepre(event){ this.video_repre = event.target.files[0] },

    onSelectFiles(event) { this.image_sliders = event.target.files } ,

    deleteTitlePrhase(inx){ this.section_zero.phrases.splice(inx, 1) },

    appendTitlePrhase(){ this.section_zero.phrases.push({ id: -1, title: "", idpage: 1, idsection: 15, idlanguage: this.language }); },

    deleteImage(id){
      // console.log("identificador de la imagen ", id)
      this.afterConfirm = this.handleDeleteImageSlider
      this.idCurrent = id
      this.dialogConfirm = true
    },

    deleteImageCarousel(id){
      this.afterConfirm = this.handleDeleteImageCarousel
      this.idCurrent = id
      this.dialogConfirm = true
    },

    handleDeleteImageCarousel(){
      // console.log("Eliminando imagen del carousel", this.idCurrent)
      const yo = this
      this.dialogLoading = true
      const config = {
        method: 'DELETE',
        url: '/talentoagv/delete_image_slider/'+this.idCurrent,
      }
      axiosIns(config).then(function(response) {
        yo.$toastr.success(response.data['message'], 'Éxito')
        yo.getMainPageData()
      }).finally(function(){
        yo.dialogLoading = false
        yo.dialogConfirm = false
      })
    },

    handleDeleteImageSlider(){
      // console.log("Eliminando imagen del slider", this.idCurrent)
      const yo = this
      this.dialogLoading = true
      const config = {
        method: 'DELETE',
        url: '/talentoagv/delete_image_slider/'+this.idCurrent,
      }
      axiosIns(config).then(function(response) {
        yo.$toastr.success(response.data['message'], 'Éxito')
        yo.getMainPageData()
      }).finally(function(){
        yo.dialogLoading = false
        yo.dialogConfirm = false
      })
    },

    uploadVideoRepre(){
      const yo = this
      let data = new FormData()
      yo.dialogLoading = true
      data.append('video', this.video_repre)
      data.append('section', 'diez');
      data.append('idlanguage', this.language);
      data.append('idpage', 1)
      const config = {
        method: 'POST',
        url: '/talentoagv/upload_video_represent',
        data: data,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
      }
      axiosIns(config)
          .then(function (response) {
            yo.$toastr.success(response.data['message'], 'Éxito')
            yo.getMainPageData()
          })
          .finally(function(){
            yo.dialogLoading = false
          })
          .catch(function (error) {
            yo.$toastr.error(response.data['message'], 'Error')
          })
    },

    uploadPhotoCarousel(){
      const yo = this
      let data = new FormData()
      yo.dialogLoading = true
      this.image_carousel.forEach((image, inx) => {
        data.append('image['+inx+']', this.image_carousel[inx])
      })
      data.append('section', 'nueve');
      data.append('idlanguage', this.language);
      data.append('idpage', 1)
      const config = {
        method: 'POST',
        url: '/talentoagv/upload_image_carousel',
        data: data,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
      }
      axiosIns(config)
        .then(function (response) {
          yo.$toastr.success(response.data['message'], 'Éxito')
          yo.getMainPageData()
        })
          .finally(function(){
            yo.dialogLoading = false
          })
          .catch(function (error) {
            yo.$toastr.error(response.data['message'], 'Error')
          })
    },

    chargeSliders(){
      const yo = this
      let data = new FormData()
      yo.dialogLoading = true
      this.image_sliders.forEach( (image, inx) => {
        data.append('image['+inx+']', this.image_sliders[inx]);
      })
      // data.append('imgs[]', this.image_sliders);
      data.append('section', 'siete');
      data.append('idlanguage', this.language);
      data.append('idpage', 1)
      const config = {
        method: 'POST',
        url: '/talentoagv/uploadSliders/',
        data: data,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
      }
      axiosIns(config)
          .then(function (response) {
            yo.$toastr.success(response.data['message'], 'Éxito')
            yo.getMainPageData()
            // console.log(response)
          })
          .finally(function (){
            yo.dialogLoading = false
          })
          .catch(function (error) {
            // console.log(error);
            yo.$toastr.error(response.data['message'], 'Error')
          })
    },

    getMainPageData(){
      const yo = this
      const config = {
        method: 'get',
        url: '/talentoagv/getMainPageData/',
      }

      if(this.$store.getters.currentAdminLanguage == 'es'){
        yo.language = '1'
      }
      else if(this.$store.getters.currentAdminLanguage == 'en'){
        yo.language = '2'
      }
      yo.dialogLoading = true

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data['result'])
          if (response.data['is_error'] === false){
            let resultado = response.data['result']
            let phrases = []
            let sliders = []
            let indices = []
            let carousel = []
            let content = { id: 0, title: '' }
            let notices = []
            for(let r of resultado){
              if(r['idlanguage'] == yo.language){
                if(r['section'] == 'cero' && r['idpage']=='1'){
                  if(r.text != "" && r.text != null){
                    phrases.push({ id: r.idcontent, title: r.text })
                  }
                  if(r.text_two != "" && r.text_two != null){
                    content = { id: r.idcontent, title: r.text_two }
                  }
                  yo.section_zero = r
                }
                if(r['section'] == 'uno' && r['idpage']=='1'){
                  yo.section_one = r
                }
                else if(r['section'] == 'dos' && r['idpage']=='1'){
                  yo.section_two = r
                }
                else if(r['section'] == 'tres' && r['idpage']=='1'){
                  yo.section_three = r
                }
                else if(r['section'] == 'cuatro' && r['idpage']=='1'){
                  yo.section_four = r
                }
                else if(r['section'] == 'cinco' && r['idpage']=='1'){
                  yo.section_five = r
                }
                else if(r['section'] == 'seis' && r['idpage']=='1'){
                  yo.section_six = r
                }
                else if(r['section'] == 'siete' && r['idpage']=='1'){
                  // yo.section_seven = r
                  sliders.push(r)
                }
                else if(r['section'] == 'ocho' && r['idpage']=='1'){
                  if(r.title_two != "" && r.title_two != null){
                    indices.push({ title: r.title_two, subtitle: r.subtitle_two, id: r.idcontent })
                  }else {
                    yo.section_eight = r
                  }
                }
                else if(r['section'] == 'nueve' && r['idpage']=='1'){
                  // yo.section_seven = r
                  carousel.push(r)
                }
                else if(r['section'] == 'diez' && r['idpage'] == '1'){
                  yo.section_ten = r
                }
                else if(r['section'] == 'once' && r['idpage'] == '1'){
                  notices.push({ id: r.idcontent, title: r.title, content: r.text, url: r.subtitle })
                }
              }
            }
            yo.section_zero['phrases'] = phrases;
            yo.section_zero['content'] = content;
            yo.section_seven = sliders
            yo.section_eight['indicadores'] = indices
            yo.section_nine = carousel
            yo.dataTableNotices = notices
            // console.log("lista de sliders",yo.section_eight)
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          yo.dialogLoading = false
        })
    },

    handlePhotoChangeSection(event, inputId) {
      const file = event.target.files[0];
      if (file) {
        if (inputId === 'section_one') {
          this.img_section_one = file;
          this.img_preview_section_one = URL.createObjectURL(file);
        } 
        else if (inputId === 'section_six') {
          this.img_section_six = file;
          this.img_preview_section_six = URL.createObjectURL(file);
        } 
      }
    },

    updateSection(page, section, language, content){
      // console.log("Actualizando los datos")
      // console.log(section)
      const yo = this
      const formData = new FormData();
      yo.dialogLoading = true

      formData.append('page', page);
      formData.append('section', section);
      formData.append('language', yo.language);
      formData.append('content', JSON.stringify(content));
      if(section == 'uno'){
        formData.append('photo', yo.img_section_one);
      }else if(section == 'seis'){
        formData.append('photo', yo.img_section_six);
      }

      const config = {
        method: 'post',
        url: '/talentoagv/updateSection/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
      }

      axiosIns(config)
        .then(function (response) {
          yo.$toastr.success(response.data['message'], 'Éxito')
          yo.getMainPageData()
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          yo.dialogLoading = true
        })
    },

    // -------------------- Valores -------------------- //

    handlePhotoChangeValue(event) {
      const file = event.target.files[0];
      if (file) {
        this.img_value = file;
        this.img_preview_value = URL.createObjectURL(file);
      }
    },

    handlePhotoChangeValueNotice(event){
      const file = event.target.files[0];
      if (file) {
        this.img_notice_value = file;
        // this.img_preview_value = URL.createObjectURL(file);
      }
    },

    loadEditModalNotice(data){
      console.log('informacion recibida', data)
      // const yo = this
      this.title_notice_value = data.title
      this.content_notice_value = data.content
      this.url_linkedin = data.url
      this.id_notice = data.id
    },

    addNoticeValue(){
      const yo = this
      const formData = new FormData();
      formData.append('title_notice_value', yo.title_notice_value);
      formData.append('content_notice_value', yo.content_notice_value);
      formData.append('idpage', 1);
      formData.append('id_notice', yo.id_notice);
      formData.append('section', 'once');
      formData.append('url', yo.url_linkedin);
      formData.append('idlanguage', 1);
      formData.append('img_value', yo.img_notice_value);
      formData.append('language', this.language);

      const config = {
        method: 'post',
        url: '/talentoagv/createNoticeValue/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
      }

      axiosIns(config)
          .then(function (response) {
            // console.log(response.data)
            if (response.data['is_error'][0] === false){
              yo.getMainPageData()
              yo.clearValuesNotice()
              yo.$toastr.success(response.data['message'], 'Éxito')
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toastr.error(response.data['message'], 'Error')
          })
          .finally(function (){

          })
    },

    addValue(){
      const yo = this       
      const formData = new FormData();
      formData.append('desc_value', yo.desc_value);
      formData.append('img_value', yo.img_value);
      formData.append('language', yo.language);

      const config = {
        method: 'post',
        url: '/talentoagv/createValue/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
      }

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data)
          if (response.data['is_error'][0] === false){
            yo.getValues()
            yo.clearValuesValue()
            yo.$toastr.success(response.data['message'], 'Éxito')
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    getValues(){
      const yo = this
      yo.dataTableValues = []
      yo.dataTableFiltValues = []
      const config = {
        method: 'get',
        url: '/talentoagv/readValues/',
      }

      if(this.$store.getters.currentAdminLanguage == 'es'){
        yo.language = '1'
      }
      else if(this.$store.getters.currentAdminLanguage == 'en'){
        yo.language = '2'
      }

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data['result'])
          if (response.data['is_error'] === false){
            let resultado = response.data['result']
            for(let r of resultado){
              if(r['key_idioma_id'] == yo.language){
                yo.dataTableValues.push(r)
                yo.dataTableFiltValues.push(r)
              }
            }
            // yo.dataTableValues = response.data['result']
            // yo.dataTableFiltValues = response.data['result']
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    loadEditModalValue(datos){
      const yo = this
      yo.id_value = datos['id']
      yo.desc_value = datos['description']
      yo.img_preview_value = datos['photo']
    },

    editValue(){
      const yo = this       
      const formData = new FormData();
      formData.append('id_value', yo.id_value);
      formData.append('desc_value', yo.desc_value);
      if (yo.img_value) {
        formData.append('img_value', this.img_value);
      }

      const config = {
        method: 'post',
        url: '/talentoagv/updateValue/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
      }

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data)
          if (response.data['is_error'] === false){
            yo.$toastr.success(response.data['message'], 'Éxito')
            yo.clearValuesValue()
            yo.getValues()
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    loadDeleteModalValue(datos){
      const yo = this
      yo.id_value = datos['id']
    },

    deleteValue(){
      const yo = this       
      const data = JSON.stringify({
        id: yo.id_value,
      })

      const config = {
        method: 'post',
        url: '/talentoagv/deleteValue/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data,
      }

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data)
          if (response.data['is_error'] === false){
            yo.$toastr.success(response.data['message'], 'Éxito')
            yo.getValues()
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    clearValuesValue(){
      const yo = this
      yo.id_value = null
      yo.desc_value = null
      yo.img_value = null
      yo.img_preview_value = null
    },

    clearValuesNotice(){
      // const yo = this
      this.title_notice_value = null
      this.content_notice_value = null
      this.url_linkedin = null
      this.id_notice = null
    },

    // --------------------- Cards --------------------- //

    handlePhotoChangeCard(event) {
      const file = event.target.files[0];
      if (file) {
        this.img_card = file;
        this.img_preview_card = URL.createObjectURL(file);
      }
    },

    addCard(){
      const yo = this       
      const formData = new FormData();
      formData.append('title_card', yo.title_card);
      formData.append('desc_card', yo.desc_card);
      formData.append('text_url_card', yo.text_url_card);
      formData.append('img_card', yo.img_card);
      formData.append('language', yo.language);

      const config = {
        method: 'post',
        url: '/talentoagv/createCard/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
      }

      axiosIns(config)
        .then(function (response) {
          if (response.status === 200){
            yo.getCards()
            yo.clearValuesCard()
            yo.$toastr.success(response.data['message'], 'Éxito')
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    getCards(){
      const yo = this
      yo.dataTableCards=[]
      yo.dataTableFiltCards=[]
      const config = {
        method: 'get',
        url: '/talentoagv/readCards/',
      }

      if(this.$store.getters.currentAdminLanguage == 'es'){
        yo.language = '1'
      }
      else if(this.$store.getters.currentAdminLanguage == 'en'){
        yo.language = '2'
      }

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data['result'])
          if (response.data['is_error'] === false){
            let resultado = response.data['result']
            for(let r of resultado){
              if(r['key_idioma_id'] == yo.language){
                yo.dataTableCards.push(r)
                yo.dataTableFiltCards.push(r)
              }
            }
            // yo.dataTableCards = response.data['result']
            // yo.dataTableFiltCards = response.data['result']
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    loadEditModalCard(datos){
      const yo = this
      yo.id_card = datos['id']
      yo.title_card = datos['title']
      yo.desc_card = datos['description']
      yo.text_url_card = datos['text_url']
      yo.img_preview_card = datos['s3_url']
    },

    editCard(){
      const yo = this       
      const formData = new FormData();
      formData.append('id_card', yo.id_card);
      formData.append('title_card', yo.title_card);
      formData.append('desc_card', yo.desc_card);
      formData.append('text_url_card', yo.text_url_card);
      if (yo.img_card) {
        formData.append('img_card', this.img_card);
      }

      const config = {
        method: 'post',
        url: '/talentoagv/updateCard/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
      }

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data)
          if (response.data['is_error'] === false){
            yo.$toastr.success(response.data['message'], 'Éxito')
            yo.clearValuesCard()
            yo.getCards()
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    loadDeleteModalCard(datos){
      const yo = this
      yo.id_card = datos['id']
    },

    deleteCard(){
      const yo = this       
      const data = JSON.stringify({
        id: yo.id_card,
      })

      const config = {
        method: 'post',
        url: '/talentoagv/deleteCard/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data,
      }

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data)
          if (response.data['is_error'] === false){
            yo.$toastr.success(response.data['message'], 'Éxito')
            yo.getCards()
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    clearValuesCard(){
      const yo = this
      yo.id_card = null
      yo.title_card = null
      yo.desc_card = null
      yo.text_url_card = null
      yo.img_card = null
      yo.img_preview_card = null
    },

    //-------------- Busqueda Local en Tabla --------------//

    localSearch(valor, datos, tabla){
      const yo = this
      let searched_value = valor.toLowerCase() // Convertir a minúsculas para búsqueda case insensitive
      let resultados = []
      
      // Recorrer cada objeto en la lista de datos
      for (let obj of datos) {
        // Recorrer cada propiedad (campo) del objeto
        for (let key in obj) {
          // Verificar si el valor de la propiedad contiene la palabra clave buscada
          if (typeof obj[key] === 'string' && obj[key].toLowerCase().includes(searched_value)) {
            resultados.push(obj); // Retornar el objeto completo si se encuentra la palabra clave
            break;
          }
        }
      }

      if(resultados){
        if(tabla == 'valores'){
          yo.dataTableFiltValues = resultados
        }else if(tabla == 'cards'){
          yo.dataTableFiltCards = resultados
        }
      }else{
        yo.dataTableFiltValues = yo.dataTableValues
        yo.dataTableFiltCards = yo.dataTableCards
      }
    },

  },
};
</script>
